/**
 * Thrown if a value doesn't exist in the cache
 */
export class ApiCacheMissError extends Error {
}
/**
 * Thrown if a response is received with an incorrect status code.
 */
export class ApiError extends Error {
    constructor(method, url, status, responseBody, responseType) {
        super(`API Error: \`${method} ${url}\` failed with status ${status}`);
        this.method = method;
        this.url = url;
        this.responseBody = responseBody;
        this.status = status;
        this.responseType = responseType;
    }
}
//# sourceMappingURL=errors.js.map